<router-link v-if="canShow" :to="location">
    <slot></slot>
</router-link>